import { useNavigate } from 'react-router-dom';
import { C, ff, t } from '../../Dashboard/components/dashboardConstants';
import { IcoChevronRight, IcoCalSm } from './ApplicationsIcons';

const STATUS_STYLE = {
  '지원완료': { bg: '#F3F3F5', color: '#888896' },
  '1차통과':  { bg: '#FFF3E0', color: '#FFA40D' },
  '2차통과':  { bg: '#E0F7FA', color: '#00ACC1' },
  '3차통과':  { bg: '#E8EAF6', color: '#3949AB' },
  '4차통과':  { bg: '#F3E5F5', color: '#8E24AA' },
  '합격':     { bg: '#E8F5E9', color: '#2E7D32' },
  '불합격':   { bg: '#FFEBEE', color: '#C62828' },
  '취소':     { bg: '#F3F3F5', color: '#888896' },
};

export default function ApplicationCard({ app }) {
  const navigate = useNavigate();
  const badge = STATUS_STYLE[app.status] || { bg: C.g200, color: C.sub };

  return (
    <div
      onClick={() => navigate(`/talent/applications/${app.id}`, {
        state: {
          castingPostId: app.castingPostId,
          title: app.title,
          status: app.status,
          company: app.company,
          role: app.role,
          date: app.date,
        },
      })}
      style={{
        height: '166px', background: C.white, borderRadius: '20px',
        border: `1px solid ${C.g200}`,
        boxShadow: '2px 2px 10px rgba(0,0,0,0.06)',
        display: 'flex', alignItems: 'center',
        padding: '0 32px', cursor: 'pointer',
        boxSizing: 'border-box', gap: '20px',
      }}
    >
      {/* 메인 정보 */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px', minWidth: 0 }}>
        {/* 제목 + 배지 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ ...t('20px', 600, C.bk), overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {app.title}
          </span>
          <span style={{
            padding: '4px 12px', borderRadius: '100px',
            background: badge.bg, color: badge.color,
            fontFamily: ff, fontSize: '13px', fontWeight: 600,
            whiteSpace: 'nowrap', flexShrink: 0,
            letterSpacing: '-0.02em',
          }}>
            {app.status}
          </span>
        </div>

        {/* 제작사 | 역할 : ... | 지원일 : ... */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={t('15px', 400, C.g400)}>{app.company}</span>
          <span style={{ color: C.g300, fontSize: '15px' }}>|</span>
          <span style={t('15px', 400, C.g400)}>역할 : {app.role}</span>
          <span style={{ color: C.g300, fontSize: '15px' }}>|</span>
          <span style={t('15px', 400, C.g400)}>지원일 : {app.date}</span>
        </div>

        {/* 마지막 업데이트 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <IcoCalSm />
          <span style={t('13px', 400, C.sub)}>마지막 업데이트 : {app.updatedAgo}</span>
        </div>
      </div>

      <IcoChevronRight />
    </div>
  );
}
